/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Merge_TextInputs */

const en_event_group_options_merge_text = /** @type {(inputs: Event_Group_Options_Merge_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merge Text`)
};

const fr_event_group_options_merge_text = /** @type {(inputs: Event_Group_Options_Merge_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionner le texte`)
};

const de_event_group_options_merge_text = /** @type {(inputs: Event_Group_Options_Merge_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text zusammenführen`)
};

const it_event_group_options_merge_text = /** @type {(inputs: Event_Group_Options_Merge_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unisci testo`)
};

const ru_event_group_options_merge_text = /** @type {(inputs: Event_Group_Options_Merge_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объединить текст`)
};

const es_event_group_options_merge_text = /** @type {(inputs: Event_Group_Options_Merge_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionar texto`)
};

const zh_cn2_event_group_options_merge_text = /** @type {(inputs: Event_Group_Options_Merge_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合并文本`)
};

const ja_event_group_options_merge_text = /** @type {(inputs: Event_Group_Options_Merge_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストの結合`)
};

const hi_event_group_options_merge_text = /** @type {(inputs: Event_Group_Options_Merge_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टेक्स्ट मर्ज करें`)
};

const pt_pt2_event_group_options_merge_text = /** @type {(inputs: Event_Group_Options_Merge_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesclar texto`)
};

/**
* | output |
* | --- |
* | "Merge Text" |
*
* @param {Event_Group_Options_Merge_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_merge_text = /** @type {((inputs?: Event_Group_Options_Merge_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Merge_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_options_merge_text(inputs)
	if (locale === "de") return de_event_group_options_merge_text(inputs)
	if (locale === "it") return it_event_group_options_merge_text(inputs)
	if (locale === "ru") return ru_event_group_options_merge_text(inputs)
	if (locale === "es") return es_event_group_options_merge_text(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_options_merge_text(inputs)
	if (locale === "ja") return ja_event_group_options_merge_text(inputs)
	if (locale === "hi") return hi_event_group_options_merge_text(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_options_merge_text(inputs)
	return en_event_group_options_merge_text(inputs)
});